import VuiBox from "components/VuiBox";
import promoter from "assets/images/promoter.png";
import { SidenavItem } from "./components/sidenav-item.component";
import pxToRem from "assets/theme/functions/pxToRem";
import VuiButton from "components/VuiButton";
import { IoClose } from "react-icons/io5";
import { useVisionUIController } from "context";
import { setMiniSidenav } from "context";
import { getUser } from "services/auth/auth.service";
import { logoUrlImg } from "../../services/constants";

export function Sidenav({ items }) {
  const session = getUser();
  const [controller, dispatch] = useVisionUIController();
  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const { miniSidenav } = controller;

  return (
    <VuiBox
      sx={({ breakpoints }) => ({
        position: "fixed",
        top: "0",
        left: "0",
        width: miniSidenav ? pxToRem(100) : pxToRem(274),
        height: "100vh",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        borderRadius: "0 20px 0 0",
        background: `linear-gradient(179deg, #060E2C 31.88%, rgba(6, 43, 99, 0.00) 100%);`,
        backgroundSize: "cover",
        zIndex: 2000,
        [breakpoints.only("md")]: {
          width: !miniSidenav ? pxToRem(100) : pxToRem(274),
          display: "flex",
          flexDirection: "column",
          alignItems: miniSidenav ? "flex-start" : "center",
        },
        [breakpoints.down("md")]: {
          display: !miniSidenav ? "none" : "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: pxToRem(274),
        },
      })}
    >
      <VuiBox
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "24px",
          width: "100%",
        }}
      >
        <VuiBox component="img" src={logoUrlImg} mb="8px" width="150px" />
        <VuiBox
          component="img"
          src={promoter}
          mb="8px"
          width="151px"
          sx={({ breakpoints }) => ({
            display: !miniSidenav ? "block" : "none",
            [breakpoints.down("lg")]: {
              display: miniSidenav ? "block" : "none",
            },
          })}
        />
        <VuiBox
          sx={{
            background:
              "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 25%, rgba(255,255,255,1) 75%, rgba(255,255,255,0) 100%);",
            height: "1px",
            width: "80%",
            marginTop: "20px",
          }}
        />
      </VuiBox>
      <VuiBox>
        {items
          .filter((item) => item.ibTypesAllowed.includes(session.ibType))
          .map((item) => (
            <SidenavItem {...item} key={item.key} miniSidenav={miniSidenav} />
          ))}
      </VuiBox>
      <VuiBox
        sx={({ breakpoints }) => ({
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "50px",
          [breakpoints.only("md")]: {
            display: miniSidenav ? "flex" : "none",
          },
          [breakpoints.up("md")]: {
            display: "none",
          },
        })}
      >
        <VuiButton
          color="white"
          margin="auto"
          variant="outlined"
          startIcon={<IoClose />}
          onClick={handleMiniSidenav}
        >
          Cerrar
        </VuiButton>
      </VuiBox>
    </VuiBox>
  );
}
